export default "__VITE_ASSET__DMjlbsy1__"